<template>
  <footer>
    <div id="footer" class="">
      <div class="footer-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-6 footer-info">
              <div class="logo text-center">
                <a :href="`${baseUrl}`">
                  <img
                    v-bind:src="`${baseUrl}assets/img/logo-text.png`"
                    class="mt-auto"
                  />
                </a>
              </div>
              <p>
                সৃজনশীলতার বিস্তার এবং দেশের নবীন-প্রবীণ লেখকদের রচনা তুলে ধরতে
                কথাপ্রকাশ-এর যাত্রা শুরু ২০০২ সাল থেকে। অগণিত পাঠকের চাহিদাকে
                সামনে রেখে নিয়মিত বিচিত্র বিষয়ক বই প্রকাশ করে চলেছে কথাপ্রকাশ।
                দেশের নবীন-প্রবীণ প্রতিভার সম্মিলন ঘটিয়ে ...<a
                  :href="`${baseUrl}about`"
                  >আরো দেখুন</a
                >
              </p>
            </div>

            <div class="col-lg-6 col-md-12 footer-links">
              <h4>গুরুত্বপূর্ণ লিঙ্ক</h4>
              <div class="row">
                <div class="col-lg-6">
                  <ul>
                    <li>
                      <img src="/assets/img/arrow-right.png" alt="" />
                      <a :href="`${baseUrl}`">হোম</a>
                    </li>
                    <li>
                      <img src="/assets/img/arrow-right.png" alt="" />
                      <a :href="`${baseUrl}about`">আমাদের সম্পর্কে</a>
                    </li>
                    <li>
                      <img src="/assets/img/arrow-right.png" alt="" />
                      <a :href="`${baseUrl}contact`">যোগাযোগ</a>
                    </li>
                    <li>
                      <img src="/assets/img/arrow-right.png" alt="" />
                      <a :href="`${baseUrl}blogs`">ব্লগ</a>
                    </li>
                  </ul>
                </div>
                <div class="col-lg-6">
                  <ul>
                    <li>
                      <img src="/assets/img/arrow-right.png" alt="" />
                      <a :href="`${baseUrl}signup`">রেজিস্ট্রেশন</a>
                    </li>
                    <li>
                      <img src="/assets/img/arrow-right.png" alt="" />
                      <a :href="`${baseUrl}privacy-policy`">গোপনীয়তা নীতি</a>
                    </li>
                    <li>
                      <img src="/assets/img/arrow-right.png" alt="" />
                      <a :href="`${baseUrl}downloads`">ক্যাটালগ</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 footer-contact">
              <h4>যোগাযোগ</h4>
              <div style="padding-top: 10px">
                <div v-html="`${contact[0].description}`"></div>
                Phone : {{ contact[0].short_description }}<br />
                <!-- Email : <span class="email">{{ contact[0].custom_field }}</span><br />
                What's App :
                <a
                  :href="`https://wa.me/${contact[0].custom_field2}`"
                  target="_blank"
                  >{{ contact[0].custom_field2 }}</a
                ><br /> -->
              </div>

              <div class="social-links mt-3">
                <span v-for="(item, key) in social" v-bind:key="key">
                  <a
                    :href="`${item.short_description}`"
                    :class="`${item.title}`"
                    target="_blank"
                    ><i :class="`fa fa-${item.title}`"></i
                  ></a>
                </span>
              </div>

              <!-- <div class="visit mt-3">
                <div>Today Visit : {{ today_visitor }}</div>
                <div>Total Visit : {{ total_visitor }}</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="copyright-row">
        <div class="row d-flex justify-content-center">
          <div class="copyright">
            Copyright © {{ new Date().getFullYear() }}
            <a href="https://kathaprokash.com/">Kathaprokash</a>. All Rights
            Reserved.
          </div>

          <div class="payment-icons">
            <img src="/assets/img/icons/bkash.svg" alt="" />
            <img src="/assets/img/icons/roket.svg" alt="" />
            <img src="/assets/img/icons/amex.svg" alt="" />
            <img src="/assets/img/icons/master.svg" alt="" />
            <img src="/assets/img/icons/visa.svg" alt="" />
            <img src="/assets/img/icons/dbbl.svg" alt="" />
          </div>
        </div>

      </div>
    </div>
    <a href="javascript:;" class="back-to-top"
      ><img src="/assets/img/down-arrow.png" alt="" />
    </a>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      sections: [],
      today_visitor: "",
      total_visitor: "",
      contact: [
        {
          description: "Loading...",
          title: "Loading...",
          custom_field: null,
        },
      ],
      social: [],
    };
  },
  methods: {
    homeSectionsName() {
      this.$http
        .get("home-sections-name")
        .then((response) => {
          this.sections = response.data;
        })
        .catch((e) => {
          this.sections = [];
        });
    },
    getContact() {
      fetch(this.APIURL + "cms-resources/Contact-Us")
        .then((response) => response.json())
        .then((json) => (this.contact = json.data));
    },
    getSocial() {
      fetch(this.APIURL + "cms-resources/Social-Links")
        .then((response) => response.json())
        .then((json) => (this.social = json.data));
    },
    getVisitors() {
      fetch(this.APIURL + "visitor-resources/count")
        .then((response) => response.json())
        .then((json) => {
          (this.today_visitor = json.today_visitor),
            (this.total_visitor = json.total_visitor);
        });
    },
    postVisitors() {
      let formData = new FormData();
      formData.append("count", 1);

      fetch(this.APIURL + "visitor-resources/count", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((json) => console.log(json));
    },
  },
  mounted() {
    this.homeSectionsName();
    this.getContact();
    this.getSocial();
    this.getVisitors();
    this.postVisitors();
  },
  updated() {
    $(".loader").fadeOut("slow");
  },
};
</script>
